import { push } from 'connected-react-router'
import { all, call, put, take, takeEvery } from 'redux-saga/effects'
import { getWhoAmI, getWhoAmIFail, getWhoAmISuccess } from '../../../common/auth/authActions'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { ROUTES } from '../../../common/Routes/routePaths'
import api from '../../../services/api.services'
import { startResetPassword, startResetPasswordFail } from './ForgotPasswordActions'
import { getErrorMsg } from '../../../common/helpers/translations'
import { currentLangString } from '../../../i18nInit'
import { setVerifyEmailContext } from '../../VerifyEmail/store/VerifyEmailActions'

function* sagaStartResetPassword({ payload }: any) {
  try {
    const { email } = payload
    yield call(api.auth.startResetPassword, {
      email,
      supportsEmailVerification: true,
      lang: currentLangString,
    })
    // Back-end has emailed a 6-digit code and set up an intermediate reset-password session.
    // Sync auth state (so the router respects the mid-verification session) and send the
    // user to the verify screen so they can enter the code. Purpose is stored in Redux (not
    // in router state) so concurrent reLocate() redirects that push to /verify-email without
    // state don't clobber it.
    yield put(setVerifyEmailContext({ purpose: 'PASSWORD_RESET', email }))
    yield put({ type: String(getWhoAmI) })
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])
    yield put(push(ROUTES.VERIFY_EMAIL.to))
  } catch (e: any) {
    yield put({ type: String(startResetPasswordFail) })
    const startResetPasswordErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('password reset start'),
    }

    yield put({ type: String(addNotification), payload: startResetPasswordErrorNotification })
  }
}

export function* forgotPasswordSagas() {
  yield all([takeEvery(String(startResetPassword), sagaStartResetPassword)])
}
